import { useExerciseMode } from '@/lib/system-status/use-exercise-mode';

// #812 — the exercise label (e.g. «POC - SANDBOX»): a discreet, always-visible strip across the top of the
// console while the deployment runs in exercise mode. Discreet on purpose: it must be
// impossible to miss on a screenshot or a projected screen, and impossible to confuse
// with an alert about the operation — it is a label on the ROOM, not on the case.
// Renders nothing (not even a spacer) off the mode, so the production shell is untouched.

export function ExerciseBanner() {
  const exercise = useExerciseMode();
  if (!exercise) return null;
  return (
    <div
      role="note"
      data-testid="exercise-banner"
      className="flex shrink-0 items-center justify-center gap-2 border-b border-amber-300 bg-amber-100 px-4 py-1 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-amber-900 print:hidden"
    >
      <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-amber-500" />
      <span>{exercise.label}</span>
    </div>
  );
}
